/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationResponsiblePersonSearchOrderBy {
    Name = 'Name'
}


export function instanceOfApplicationResponsiblePersonSearchOrderBy(value: any): boolean {
    for (const key in ApplicationResponsiblePersonSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(ApplicationResponsiblePersonSearchOrderBy, key)) {
            if (ApplicationResponsiblePersonSearchOrderBy[key as keyof typeof ApplicationResponsiblePersonSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationResponsiblePersonSearchOrderByFromJSON(json: any): ApplicationResponsiblePersonSearchOrderBy {
    return ApplicationResponsiblePersonSearchOrderByFromJSONTyped(json, false);
}

export function ApplicationResponsiblePersonSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonSearchOrderBy {
    return json as ApplicationResponsiblePersonSearchOrderBy;
}

export function ApplicationResponsiblePersonSearchOrderByToJSON(value?: ApplicationResponsiblePersonSearchOrderBy | null): any {
    return value as any;
}

export function ApplicationResponsiblePersonSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonSearchOrderBy {
    return value as ApplicationResponsiblePersonSearchOrderBy;
}

